// src/api/advertisements.js
import api from "./axios"; // ⚠️ عدّل المسار لو ملف الـ axios instance بتاعك في مكان تاني

// حسب الـ project urls.py: path("advertisement/", include("advertisement.urls"))
// يعني المسار الكامل هو /advertisement/dashboard/ads/
const BASE = "/advertisement/dashboard/ads";

function buildFormData(payload) {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    // منتخطاش false عشان is_active بيتبعت حتى لو false
    if (value === undefined || value === null) return;
    if (typeof value === "string" && value === "") return;
    formData.append(key, value);
  });
  return formData;
}

export const advertisementsAPI = {
  // GET /dashboard/ads/  -> بترجع array مباشرة (مفيش success/data wrapper، دي generics.ListCreateAPIView)
  list: () => api.get(`${BASE}/`).then((r) => r.data),

  get: (id) => api.get(`${BASE}/${id}/`).then((r) => r.data),

  // payload: { title, button_name, image (File), link_url, order, is_active, start_date, end_date }
  create: (payload) =>
    api
      .post(`${BASE}/`, buildFormData(payload), {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data),

  // بنستخدم PATCH عشان لو المستخدم مغيرش الصورة منبعتهاش تاني
  update: (id, payload) =>
    api
      .patch(`${BASE}/${id}/`, buildFormData(payload), {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data),

  remove: (id) => api.delete(`${BASE}/${id}/`).then((r) => r.data),
};